import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { circularProgressClasses } from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import "./loader.scss";
import { pageLocale } from "../../utils/locale";

const ProgressiveLoader = (props) => {
  const { loader } = props;
  const { please_wait } = pageLocale("common");

  return (
    <>
      <svg viewBox="0 0 300 87">
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="my_gradient"
            x1="57.887"
            y1="8.45958"
            x2="80.687"
            y2="27.9637"
          >
            <stop className="stop-svg" />
            <stop offset="3" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <Box sx={{ position: "relative" }} className="box-wrapper">
          <CircularProgress
            className="circular-first"
            variant="determinate"
            sx={{
              color: (theme) =>
                theme.palette.grey[theme.palette.mode === "light" ? 100 : 500],
            }}
            size={80}
            thickness={4}
            {...props}
            value={100}
          />
          <CircularProgress
            variant="indeterminate"
            disableShrink
            sx={
              ({
                animationDuration: "600ms",
                position: "absolute",
                left: 0,
                [`& .${circularProgressClasses.circle}`]: {
                  strokeLinecap: "round",
                },
              },
              { "svg circle": { stroke: "url(#my_gradient)" } })
            }
            size={80}
            thickness={4}
            {...props}
          />
          <Typography className="loader-text">{please_wait}</Typography>
        </Box>
      </Backdrop>
    </>
  );
};

export default ProgressiveLoader;
